module.exports = __webpack_public_path__ + "img/index-svg-black.628a0785.svg";